import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationVariant } from 'src/js/notification/notification';
import { createAndDispatchNotification } from 'src/js/notification/notification-helper';

export const NotificationsTest: React.FunctionComponent = () => {
  const { t } = useTranslation();
  let count = 2;
  useEffect(() => {
    createAndDispatchNotification('testing notification 1', NotificationVariant.SUCCESS, t);
    createAndDispatchNotification('testing notification 2', NotificationVariant.SUCCESS, t);
    setInterval(() => {
      count++;
      createAndDispatchNotification(`testing notification ${count}`, NotificationVariant.SUCCESS, t);
    }, 1000);
  }, []);
  return <>{}</>;
};
